import { cn } from '@/lib/utils';

export function Container({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        'max-w-7xl uw:max-w-[1600px] suw:max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8 uw:px-12',
        className
      )}
    >
      {children}
    </div>
  );
}
